/**
 * Mirrors interlude's server-side rule exactly (see
 * `_validate_subdomain_format`, interlude PR #1216) — a single DNS label,
 * not a full domain: 3-63 chars, lowercase alphanumeric, hyphens allowed
 * only in the interior. Consecutive hyphens (e.g. "a--b") are intentionally
 * allowed, matching the backend regex.
 */
const SUBDOMAIN_REGEX = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/;

/**
 * Expects an already-normalized (trim + lowercase) value, matching how
 * interlude validates format only after normalizing — see
 * `normalizeSubdomain` below.
 */
function isValidSubdomain(value: string): boolean {
  return SUBDOMAIN_REGEX.test(value);
}

/**
 * Trim + lowercase, matching interlude's own normalization
 * (`subdomain.strip().lower()`) so the client and server never disagree on
 * what value is being checked/saved.
 */
const normalizeSubdomain = (value: string): string =>
  value.trim().toLowerCase();

export { isValidSubdomain, normalizeSubdomain };
